module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '6okzen78',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
